import React, { useState, useEffect, useRef } from 'react';
import '../styles/Root.css';
import '../styles/DevenirAdherent.css';
import '../styles/deveniradherentmodal.css';
import devenirAdherentImage from '../assets/deveniradherent/deveniradherent.jpg';

const DevenirAdherent = () => {
    const optinInputRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [membershipType, setMembershipType] = useState('individual');
    const [donationAmount, setDonationAmount] = useState(0);
    const [showDonationInput, setShowDonationInput] = useState(false);
    const [customerInfo, setCustomerInfo] = useState({
        lastName: '',
        firstName: '',
        birthDate: '',
        birthPlace: '',
        status: '',
        grade: '',
        arm: '',
        activityStatus: '',
        address: '',
        postalCode: '',
        city: '',
        phonePrefix: '+33',  // Valeur par défaut
        phone: '',
        email: '',
    });
    const [statusMessage, setStatusMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fadeElements = document.querySelectorAll('.fade-in');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = 1;
                }
            });
        }, {
            threshold: 0.1
        });

        fadeElements.forEach(element => {
            observer.observe(element);
        });

        return () => {
            // Nettoyage lors du démontage du composant
            fadeElements.forEach(element => {
                observer.unobserve(element);
            });
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomerInfo(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleMembershipTypeChange = (e) => {
        setMembershipType(e.target.value);
    };

    const openModal = () => {
        console.log("Ouverture de la modale");
        setIsModalOpen(true);
    };

    const closeModal = () => {
        console.log("Fermeture de la modale");
        setIsModalOpen(false);
        setError(null);
        setStatusMessage('');
        setShowDonationInput(false);
        setDonationAmount(0);
    };

    const handleDonationToggle = () => {
        setShowDonationInput(prev => !prev);
        if (!showDonationInput) {
            setDonationAmount(0); // Réinitialise le montant quand on active le don
        }
    };

    const validateForm = () => {
        // Réinitialiser l'erreur avant validation
        setError(null);

        const requiredFields = ['lastName', 'firstName', 'birthDate', 'birthPlace', 'status', 'address', 'postalCode', 'city', 'phonePrefix', 'phone', 'email'];
        const missingFields = requiredFields.filter(field => !customerInfo[field]);

        if (missingFields.length > 0) {
            console.log("Champs manquants:", missingFields);
            setError(`Veuillez remplir tous les champs obligatoires`);
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(customerInfo.email)) {
            console.log("Email invalide:", customerInfo.email);
            setError('Veuillez entrer une adresse email valide');
            return false;
        }

        const phoneRegex = /^[0-9]{9,10}$/;
        if (!phoneRegex.test(customerInfo.phone)) {
            console.log("Téléphone invalide:", customerInfo.phone);
            setError('Veuillez entrer un numéro de téléphone valide (9-10 chiffres)');
            return false;
        }

        // Vérification de la case à cocher
        if (optinInputRef.current && !optinInputRef.current.checked) {
            console.log("Case à cocher d'adhésion non cochée");
            setError('Veuillez confirmer votre adhésion en cochant la case');
            return false;
        }

        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Formulaire soumis, validation en cours...");

        // Réinitialiser les erreurs avant la validation
        setError(null);

        if (!validateForm()) {
            console.log("Échec de la validation du formulaire");
            return;
        }

        console.log("Validation réussie, ouverture de la modale...");
        openModal();
    };

    const handlePaymentSubmit = async (e) => {
        if (e) e.preventDefault();

        setError(null);

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        setStatusMessage('Préparation du paiement...');

        try {
            const membershipFee = membershipType === 'individual' ? 20 : 150;
            const totalAmount = membershipFee + parseFloat(donationAmount || 0);

            const paymentData = {
                email: customerInfo.email,
                amount: totalAmount,
                customer_id: `customer_${Date.now()}_${Math.floor(Math.random() * 1000)}`,
                firstName: customerInfo.firstName,
                lastName: customerInfo.lastName,
                mobileNumber: `${customerInfo.phonePrefix}${customerInfo.phone}`,
                address: customerInfo.address,
                city: customerInfo.city,
                postcode: customerInfo.postalCode,
                membershipType,
                donationAmount,
                birthDate: customerInfo.birthDate,
                birthPlace: customerInfo.birthPlace,
                status: customerInfo.status,
                grade: customerInfo.grade,
                arm: customerInfo.arm,
                activityStatus: customerInfo.activityStatus,
                cart: [] // No cart items for this payment
            };

            console.log("Données de paiement:", paymentData);

            // Fix: Use the correct API endpoint path
            const response = await fetch('/api/deveniradherent.php?endpoint=create-payment-adherent', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(paymentData),
                mode: 'cors',
                credentials: 'include'
            });

            console.log("Réponse du serveur:", response.status);

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: 'Erreur de format de réponse' }));
                throw new Error(`Erreur serveur: ${response.status} - ${errorData.error || 'Erreur inconnue'}`);
            }

            const result = await response.json();

            if (result && result.payment_url && result.payment_id) {
                setStatusMessage('Redirection vers la page de paiement...');
                localStorage.setItem('current_payment_id', result.payment_id);
                localStorage.setItem('current_customer_id', paymentData.customer_id);
                window.location.href = result.payment_url;
            } else {
                setStatusMessage('');
                setError('Erreur: La réponse de paiement ne contient pas l\'URL nécessaire.');
            }
        } catch (error) {
            console.error("Erreur complète:", error);
            setStatusMessage('');
            setError(`Erreur lors de la préparation du paiement: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <main>
            <section className="hero fade-in">
                <h1>Devenir Adhérent</h1>
                <p>Rejoignez les Amis du Musée des Troupes de Marine et soutenez leurs actions en remplissant le formulaire ci-dessous.</p>
            </section>

            <section className="content-section fade-in">
                <h2>Pourquoi Devenir Adhérent ?</h2>
                <p>Créée en 1979, les Amis du Musée des Troupes de marine est une association qui apporte son concours à l'enrichissement, à la conservation, à la mise en valeur et au rayonnement du patrimoine culturel et artistique constitué par les collections du musée, lesquelles témoignent de l'engagement et des vertus militaires dont les Troupes de la Marine avant 1900 puis les troupes coloniales de 1900 à 1958 et enfin les Troupes de marine ont fait preuve au service de la France.</p>
                <p>Les Amis du musée des Troupes de marine, association de type Loi 1901 :</p>
                <ul className="custom-list">
                    <li>Achètent des pièces de collection et des documents ;</li>
                    <li>Participent au rayonnement du musée (organisation de conférences…) ;</li>
                    <li>Soutiennent les actions éducatives conçues et programmées par le Conservateur ;</li>
                    <li>Promeuvent les activités du musée (actions de communication, réalisations d'affiches, de flyers…).</li>
                </ul>
                <p>Devenir adhérent, c'est soutenir nos actions, c'est prendre part au développement de l'association ! Pour cela, il vous suffit de remplir le bulletin d'adhésion ci-dessous et vous acquitter du paiement de la cotisation.</p>
                <p>Les Amis du musée, déclarés et reconnus d'intérêt général, sont habilités à recevoir des dons ouvrant droit à avantage fiscal. Tout donateur bénéficie d'un crédit d'impôts égal à 66% du montant versé dans la limite de 20% de son revenu imposable.</p>
            </section>

            <section className="content-section fade-in">
                <img src={devenirAdherentImage} alt="Adhérents des Amis du Musée" className="img-feature" />
            </section>

            <section className="content-section fade-in">
                <h2>Comment soutenir le musée des Troupes de marine ?</h2>
                <p>En adhérant aux Amis du musée (AAMTDM) ou / et en faisant un don.</p><br />
                <p><span style={{ color: 'var(--tdm-red)' }}>Vous souhaitez adhérer à l'association des Amis du musée des Troupes de marine : </span> remplissez le formulaire et envoyez votre chèque à l'ordre de AAMTDM à l'adresse : AAMTDM BP 10 83601 FREJUS cedex.</p>
                <p>Votre adhésion à l'Association des Amis du Musée sera prise en compte à la réception de votre chèque.</p>
                <p>Pour les particuliers, le montant de la cotisation est de 20,00 €.</p>
                <p>Pour les associations et les amicales, celle-ci est de 150,00 €.</p>
                <p>Le titre de membre à vie est conféré à l'adhérent qui effectue un versement supérieur ou égal à 600,00 €.</p><br />
                <p><span style={{ color: 'var(--tdm-red)' }}>Vous souhaitez faire un don :</span> remplissez le formulaire et envoyez votre chèque à l'ordre de AAMTDM à l'adresse : AAMTDM BP 10 83601 FREJUS cedex.</p>
                <p>L'AAMTDM, reconnue d'intérêt général, vous délivrera un reçu fiscal afin de vous faire bénéficier d'un crédit d'impôts égal au deux tiers du montant de votre don. Un don de 60 € vous revient à 20 €.</p>
            </section>

            <section className="form-section fade-in">
                <h2>Formulaire d'Adhésion</h2>
                {/* Affichage des erreurs en haut du formulaire */}
                {error && (
                    <div className="error-message" style={{
                        color: 'red',
                        padding: '10px',
                        marginBottom: '15px',
                        border: '1px solid red',
                        borderRadius: '4px',
                        backgroundColor: 'rgba(255, 0, 0, 0.1)'
                    }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <label htmlFor="last-name">Nom <span className="required">*</span></label>
                    <input
                        type="text"
                        id="last-name"
                        name="lastName"
                        value={customerInfo.lastName}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="first-name">Prénom(s) <span className="required">*</span></label>
                    <input
                        type="text"
                        id="first-name"
                        name="firstName"
                        value={customerInfo.firstName}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="birth-date">Date de naissance <span className="required">*</span></label>
                    <input
                        type="date"
                        id="birth-date"
                        name="birthDate"
                        value={customerInfo.birthDate}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="birth-place">Lieu de naissance <span className="required">*</span></label>
                    <input
                        type="text"
                        id="birth-place"
                        name="birthPlace"
                        value={customerInfo.birthPlace}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="status">Vous êtes <span className="required">*</span></label>
                    <select
                        id="status"
                        name="status"
                        value={customerInfo.status}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Sélectionnez</option>
                        <option value="civil">Civil</option>
                        <option value="military">Militaire</option>
                    </select>

                    <label htmlFor="grade">Grade</label>
                    <input
                        type="text"
                        id="grade"
                        name="grade"
                        value={customerInfo.grade}
                        onChange={handleChange}
                    />

                    <label htmlFor="arm">Arme</label>
                    <input
                        type="text"
                        id="arm"
                        name="arm"
                        value={customerInfo.arm}
                        onChange={handleChange}
                    />

                    <label htmlFor="activity-status">Statut <span className="required">*</span></label>
                    <select
                        id="activity-status"
                        name="activityStatus"
                        value={customerInfo.activityStatus}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Sélectionnez</option>
                        <option value="retired">En retraite</option>
                        <option value="honorary">Honorariat</option>
                        <option value="reserve">Réserve</option>
                        <option value="active">En activité</option>
                    </select>

                    <label htmlFor="address">Adresse <span className="required">*</span></label>
                    <input
                        type="text"
                        id="address"
                        name="address"
                        value={customerInfo.address}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="postal-code">Code Postal <span className="required">*</span></label>
                    <input
                        type="text"
                        id="postal-code"
                        name="postalCode"
                        value={customerInfo.postalCode}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="city">Ville <span className="required">*</span></label>
                    <input
                        type="text"
                        id="city"
                        name="city"
                        value={customerInfo.city}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="phone">Téléphone <span className="required">*</span></label>
                    <div className="phone-container">
                        <select
                            id="phone-prefix"
                            name="phonePrefix"
                            value={customerInfo.phonePrefix}
                            onChange={handleChange}
                            required
                        >
                            <option value="+33">France (+33)</option>
                            {/* Add other country options as needed */}
                        </select>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={customerInfo.phone}
                            onChange={handleChange}
                            placeholder="9 ou 10 chiffres"
                            required
                        />
                    </div>

                    <label htmlFor="email">E-mail <span className="required">*</span></label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={customerInfo.email}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="membership-type">Type d'Adhésion <span className="required">*</span></label>
                    <select
                        id="membership-type"
                        name="membershipType"
                        value={membershipType}
                        onChange={handleMembershipTypeChange}
                        required
                    >
                        <option value="individual">Individuel</option>
                        <option value="family">Association</option>
                    </select>

                    <div className="optin-container">
                        <input
                            type="checkbox"
                            id="optin"
                            name="optin"
                            ref={optinInputRef}
                            required
                        />
                        <label htmlFor="optin">Je valide le formulaire.</label>
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                    >
                        {loading ? 'Traitement...' : 'J\'adhère à l\'AAMTDM'}
                    </button>
                </form>
            </section>

            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={closeModal}>&times;</span>
                        <h2>Finalisez votre adhésion</h2>

                        <div className="order-summary">
                            <h3>Récapitulatif</h3>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Cotisation :</td>
                                        <td>{membershipType === 'individual' ? '20,00 €' : '150,00 €'}</td>
                                    </tr>
                                    {showDonationInput && (
                                        <tr>
                                            <td>Don :</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    value={donationAmount}
                                                    onChange={(e) => setDonationAmount(e.target.value)}
                                                    required
                                                /> €
                                            </td>
                                        </tr>
                                    )}
                                    <tr className="total-row">
                                        <td><strong>Total à payer :</strong></td>
                                        <td><strong>{(membershipType === 'individual' ? 20 : 150) + parseFloat(donationAmount || 0)} €</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="donation-section">
                            <p>Je souhaite faire un don</p>
                            <button type="button" onClick={handleDonationToggle} className="btn btn-secondary">
                                {showDonationInput ? 'Non' : 'Oui'}
                            </button>
                        </div>

                        {error && <div className="error-message">{error}</div>}

                        <div className="status-message">
                            {statusMessage && <div className="status">{statusMessage}</div>}
                        </div>

                        <button
                            className="checkout-button"
                            type="button"
                            onClick={handlePaymentSubmit}
                            disabled={loading}
                        >
                            {loading ? 'Traitement en cours...' : 'Je paye'}
                        </button>
                    </div>
                </div>
            )}
        </main>
    );
};

export default DevenirAdherent;
